<form
  class="form border-radius"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [appScrollToInvalidFieldOnFormSubmit]
  [scrollElement]="ScrollElements.WINDOW"
>
  <app-account-information />
  <app-account-avatar />
  <app-billing-information />
  <app-payment-information />
  <app-account-save-information />
</form>
